<template>
  <!-- 个人预存记录 -->
  <el-card shadow="never" class="real_card">
    <div slot="header" class="clearfix">
      <el-button type="text" class="backBtn" @click="changeBack">返回</el-button>
      <span class="font18">个人预存记录</span>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%;min-height: 550px"
      :empty-text="'暂无预存记录'"
      :header-cell-style="{background:'#F5F5F5'}"
    >
      <el-table-column prop="prestoreCode" label="预存编号" align="center"></el-table-column>
      <el-table-column prop="invoiceCode" label="预存发票号" align="center"></el-table-column>
      <el-table-column prop="amountDeposited" label="预存金额" align="center">
        <template slot-scope="scope">¥{{scope.row.amountDeposited || '0.00'}}</template>
      </el-table-column>
      <el-table-column prop="registerDate" label="登记时间" align="center"></el-table-column>
    </el-table>
    <el-pagination
      background
      v-if="total > 0"
      style="text-align: right;margin-top: 10px"
      layout="total,prev, pager, next,sizes,jumper"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      @current-change="selPageChange"
      @size-change="handleSizeChange"
    ></el-pagination>
  </el-card>
</template>
<script>
import { prestoreRecord } from "@/api/request";
import { getClient } from "@/plugins/auth";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      prestoreRecordParams: {
        clientId: JSON.parse(getClient()).clientId,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },
  mounted() {
    this.getList();
    document.documentElement.scrollTop = 0;
  },
  methods: {
    getList() {
      this.loading = true
      prestoreRecord(this.prestoreRecordParams).then(res => {
        this.tableData = res.rows;
        this.total = res.total;
        this.loading = false
      });
    },
    selPageChange(page) {
      this.prestoreRecordParams.pageNum = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.prestoreRecordParams.pageSize = val;
      this.getList();
    },
    changeBack() {
      this.$emit("back");
    }
  }
};
</script>